module.exports = __webpack_public_path__ + "pt.6a4e0bafde97b03ae081.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/pt.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/pt.svg
// module chunks = styles